<div class="overflow-hidden">
  <div class="col-sm-12 pl-0 pr-0"
    *ngIf="(memberId !== undefined && memberId !== null) || (caseId !== undefined && caseId !== null)">
    <div class="h-100 text-center soft-green">
      <div class="row pl-2">
        <div class="col-xl-2 col-2 text-left my-auto" style="padding-left:30px;max-width:143px;width:143px">
          <h6>
            <span class="text-uppercase dark-green">{{'FLAGS' | translate}}</span>
          </h6>
        </div>
        <div [ngClass]="{'col-xl-10 col-10': flags.length > 0 || taskIconAlwaysVisible || !isMemberContext}"
          class="text-left">
          <button *ngFor="let item of flags"
            class="btn btn-outline-dark float-left custom-button ml-2 mt-2 flag-priority-{{item.priority.code}}"
            (click)="openFlagDialog(item, false)">
            {{item.description}}
            <i *ngIf="item.category.icon" title="{{item.category.displayName}}" style="color:inherit;width:15px"
              class="fas ml-2 {{item.category.icon}}">
            </i>
          </button>
          <button class="btn btn-outline-dark float-left custom-button border border-secondary m-2"
            (click)="openFlagDialog(null, true)">
            <span *ngIf="memberId" class="text-uppercase mr-2">&nbsp;{{'ADD-MEMBER-FLAG-MULTI' |
              translate:patientLabel}}</span>
            <span *ngIf="caseId" class="text-uppercase mr-2">&nbsp;{{'ADD-CASE-FLAG-MULTI' | translate}}</span>
            <i class="fas fa-plus-circle"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Flag detail dialog -->
<app-flag-edit #flagEdit [model]="selectedFlag" [memberId]="memberId" [caseId]="caseId"
  (save)="saveChangesHandler($event)" (cancelling)="cancelChangesHandler()" (delete)="deleteHandler($event)">
</app-flag-edit>